export default __webpack_public_path__ + "static/media/info.15ba24a9.svg";